// extracted by mini-css-extract-plugin
export var standaloneTable = "_fz-0";
export var standaloneTableWithBodyFill = "_fz-1";
export var withExtraHeader = "_fz-2";